var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading,"variant":"white","opacity":1}},[_c('b-card',{staticClass:"calendar-card"},[_c('full-calendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }